import z from "zod"

export const DragDropBaseSchema = z.object({
  id: z.string(),
  origin: z.string().optional(),
  type: z.string(),
  data: z.any(),
  meta: z.any().optional()
})
